import styled, { css } from 'styled-components';

import { BottomSheet as BottomSheetComponent } from '@xingternal/bottom-sheet';
import { Button as ButtonComponent, TextButton as TextButtonComponent } from '@xingternal/button';
import { IllustrationPremiumSpotBell } from '@xingternal/illustrations';
import { mediaConfined, mediaConfinedOnly } from '@xingternal/layout-tokens';
import { PopUpWindow as PopUpWindowComponent } from '@xingternal/pop-up-window';
import { FormField as FormFieldComponent } from '@xingternal/text-field';
import { spaceM, spaceS, spaceXL } from '@xingternal/tokens';
import { BodyCopy as BodyCopyComponent, Headline as HeadlineComponent } from '@xingternal/typography';

import { AlertButton as AlertButtonComponent } from '../alert-button';

export const BottomSheet = styled(BottomSheetComponent)`
  & > div {
    display: flex;
    flex-flow: column;
    align-items: center;
    padding: ${spaceXL};
  }
`;

export const PopUpWindow = styled(PopUpWindowComponent)`
  && > div {
    display: flex;
    flex-flow: column;
    align-items: center;
    padding: 99px 48px 99px;

    @media ${mediaConfinedOnly} {
      width: 75vw;
      max-height: 75vh;
    }
  }
`;

export const Image = styled(IllustrationPremiumSpotBell)`
  margin: ${spaceM} 0 ${spaceXL};

  @media (${mediaConfined}) {
    margin-top: 0;
  }
`;

export const BodyCopy = styled(BodyCopyComponent)<{ variant: number }>`
  text-align: center;
  && {
    ${({ variant }) =>
      variant === 1
        ? css`
            margin-bottom: ${spaceS};
          `
        : css`
            margin-bottom: ${spaceXL};
          `}
  }
`;

export const Headline = styled(HeadlineComponent)<{ variant: number }>`
  text-align: center;
  && {
    ${({ variant }) =>
      variant === 1
        ? css`
            margin-bottom: ${spaceXL};
          `
        : css`
            margin-bottom: ${spaceS};
          `}
  }
`;

export const TextButton = styled(TextButtonComponent)`
  margin-top: ${spaceS};

  @media (${mediaConfined}) {
    margin-top: ${spaceM};
  }
`;

export const FormField = styled(FormFieldComponent)`
  width: 100%;
  margin-bottom: ${spaceXL};
`;

export const AlertButton = styled(AlertButtonComponent)`
  flex-shrink: 0;
`;

export const SubmitButton = styled(ButtonComponent)`
  flex-shrink: 0;
`;
